import api from "../api/axios";

  

const LoginService = {
 
    register: async (params) => {
        const res = await api.post("/auth/register",  params );
        return res.data.data || res.data;
    },
    login: async (params) => {
        const res = await api.post("/auth/login", { params });
        return res.data.data || res.data;
    }, 
 
};

export default LoginService;